module.exports = __webpack_public_path__ + "img/nav-design-classic.4ed625c.webp";